import { Alert, AlertDescription, AlertIcon } from "@chakra-ui/alert";
import { useTranslation } from "react-i18next";
import { InfoCircleIcon } from "shared/icons/InfoCircleIcon";
import { formatIsoDateToDisplay } from "shared/utils/DateUtils";

interface InvestorTransferBackdatedWarningBannerProps {
  recordedDate: string;
  calculatedDate: string;
}
export const InvestorTransferBackdatedWarningBanner: React.FC<
  InvestorTransferBackdatedWarningBannerProps
> = ({ recordedDate, calculatedDate }) => {
  const { t } = useTranslation(["common", "investorTransfer"]);

  if (new Date(recordedDate) < new Date(calculatedDate)) {
    return (
      <Alert status="warning" mb="16px">
        <AlertIcon>
          <InfoCircleIcon />
        </AlertIcon>
        <AlertDescription>
          {t("investorTransfer:backdatedWarning", {
            recordedDate: formatIsoDateToDisplay(recordedDate),
            calculatedDate: formatIsoDateToDisplay(calculatedDate),
          })}
        </AlertDescription>
      </Alert>
    );
  }
  return null;
};
